
import { isNull } from "../../../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import NGTConfigKey from "../../base/NGTConfigKey";
import Scenario from "../Scenario";
/**
 * InitializeScenariosCommand.js
 * 
 * Created on Oct 17, 2013, 2:36:14 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class InitializeScenariosCommand {
    constructor(config, scenarioLibrary) {
        this._config = config;
        this._scenarioLibrary = scenarioLibrary;
    }

    execute(event) {
        this.initializeModel();
    }

    initializeModel() {
        var scenarios = this._config.getValue(NGTConfigKey.SCENARIOS);
        var defaultScenarioID;

        for (var i = 0; i < scenarios.length; i++) {
            var scenarioNode = scenarios[i];
            
            var scenario = new Scenario();
            scenario.id = scenarioNode.scenarioID;
            scenario.name = scenarioNode.name;
            scenario.storyID = scenarioNode.storyID;

            if (scenarioNode.autoStart) {
                defaultScenarioID = scenarioNode.scenarioID;
            }

            this._scenarioLibrary.addScenario(scenario);
            if (!isNull(defaultScenarioID) && scenario.id === defaultScenarioID) {
                this._scenarioLibrary.setDefaultScenario(scenario);
            }

        }

    }
}